import { render } from "./socialPost.vue?vue&type=template&id=3d5ebc19"
import script from "./socialPost.vue?vue&type=script&lang=js"
export * from "./socialPost.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__